import { $generateDOMFromNodes } from '@lexical/html';
import { $getRoot, type LexicalEditor } from 'lexical';

import type { EditorMode } from '../types';
import { tableWidthsToPercent } from './tableWidths';

/**
 * The editor's value as the host stores it: text in plain mode, HTML in rich mode.
 * - Table widths are written as percentages (see `tableWidths.ts`), matching Froala's markup.
 * - Needs an active editor for the HTML export: call it in `editor.read()` or `editorState.read(fn, { editor })`.
 */
export const $getContent = (editor: LexicalEditor, mode: EditorMode): string => {
  if (mode !== 'rich') return $getRoot().getTextContent();

  // Same as `$generateHtmlFromNodes`, but the DOM is post-processed before serialising
  const container = $generateDOMFromNodes(document.createElement('div'), null, editor);
  tableWidthsToPercent(container);
  return container.innerHTML;
};
